import PropTypes from "prop-types";
import React, { useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { checkEmailValidate, requestPassword } from "./request";
import { toast } from "react-toastify";

const ForgetPasswordPage = (props: any) => {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState<any>();
  const Navigate = useNavigate();
  const validation: any = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Please enter a valid email address")
        .required("Please Enter Your Email to send instructions"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      try {
        const checkRes: any = await checkEmailValidate(values.email);
        if (checkRes.status == true) {
          const res: any = await requestPassword(values.email);
          console.log("res.message onsubmit", res.message)
          setStatus(res.status);
          setMessage(res.message);
          if (res.status == true) {
            resetForm();
            setTimeout(() => {
              Navigate("/login");
            }, 15000);
          }
        } else {
          setStatus(false);
          setMessage(checkRes.message);
        }
      } catch (error) {
        console.error(error);
        setStatus(false);
        setMessage("Something went wrong.");
      } finally {
        setSubmitting(false);
      }
    }
  });

  console.log("values.email", validation.values.email)
  console.log("validateion", validation.errors)
  console.log("status", status)
  console.log("message", message)
  document.title = " Paal Dappa | Admin panel";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">

          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-0 mb-0 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoLight} alt="" height="120" width="120" />
                    </Link>
                  </div>
                  {/* <p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p> */}
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-3">

                  <CardBody className="p-3">
                    <div className="text-center mt-1">
                      <h5 className="text-primary">Forgot Password?</h5>
                      <p className="text-muted">Reset password with Paal Dappa</p>

                      <i className="ri-mail-send-line display-5 text-success mb-3"></i>

                    </div>

                    {/* <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                      Please enter your Email.<br />Instructions will be sent to your Email.
                    </Alert> */}
                    <div className="p-2">
                      {message && (
                        <Alert color={status ? "success" : "danger"}>
                          {message}
                        </Alert>
                      )}
                      {status && (
                        <div className="text-center">
                    
                          <Link to="/login" className="btn btn-primary mt-2">Go to Login</Link>
                        </div>
                      )}

                      {/* {validation.values.email != "" && message && (
                        <Alert color={status ? "success" : "danger"} style={{ marginTop: "13px" }}>
                          {message}
                        </Alert>
                      )} */}
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-4">
                          <Label className="form-label">Email</Label>
                          <Input
                            name="email"
                            className="form-control"
                            placeholder="Enter Email"
                            type="email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur} // required!
                            value={validation.values.email || ""}

                            invalid={validation.touched.email && !!validation.errors.email}
                          />
                          {validation.touched.email && validation.errors.email && (
                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                          )}

                        </div>

                        <div className="text-center mt-4">
                          <button className="btn btn-success w-100" type="submit">Send Reset Link</button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>

                <div className="mt-4 text-center">
                  <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link> </p>
                </div>

              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
